import { createContext, useContext, useMemo, type ReactNode } from "react";
import { resolveEnvironment, type EnvironmentConfig } from "./environment";

const EnvironmentContext = createContext<EnvironmentConfig | null>(null);

export function EnvironmentProvider({ children }: { children: ReactNode }) {
  const env = useMemo(() => resolveEnvironment(), []);

  return <EnvironmentContext.Provider value={env}>{children}</EnvironmentContext.Provider>;
}

export function useEnvironment(): EnvironmentConfig {
  const ctx = useContext(EnvironmentContext);
  if (!ctx) throw new Error("useEnvironment must be used within EnvironmentProvider");
  return ctx;
}
